// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".benefits[data-v-9cf19166]{background-image:radial-gradient(50vw 500px at center -200px,var(--v-accentPurple-base) 0,transparent 90%)}img[data-v-9cf19166]{max-width:100%;height:auto}hr[data-v-9cf19166]{max-width:50px}.benefit-card[data-v-9cf19166]{max-width:320px}.rewards-prompt-container p[data-v-9cf19166]{max-width:var(--content-max-width)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
